export default "__VITE_ASSET__DIysB4pN__"